/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiGroup, LockElement, LockedContextDto } from '@Model';
import type { HttpActions, ListInfo, ListRequest, ListRequestWithIds, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of GroupsController.
 */
export class GroupsRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls POST /groups:prefill
     */
    public createPrefilled(): Promise<Result<ApiGroup>> {
        return this.http.post<Result<ApiGroup>, undefined>('/groups:prefill', undefined);
    }

    /**
     * Calls POST /groups/{primaryId}/start_edit_mode
     */
    public startEditMode(primaryId: string): Promise<Result<LockedContextDto<ApiGroup>>> {
        return this.http.post<Result<LockedContextDto<ApiGroup>>, undefined>(`/groups/${primaryId}/start_edit_mode`, undefined);
    }

    /**
     * Calls POST /groups/{draftId}/commit
     */
    public commitDraft(draftId: string): Promise<Result<ApiGroup>> {
        return this.http.post<Result<ApiGroup>, undefined>(`/groups/${draftId}/commit`, undefined);
    }

    /**
     * Calls POST /groups/locks
     */
    public lockAll(ids: string[]): Promise<Result<ApiGroup[]>> {
        return this.http.post<Result<ApiGroup[]>, string[]>('/groups/locks', ids);
    }

    /**
     * Calls POST /groups/{primaryId}/locks
     */
    public lock(primaryId: string): Promise<Result<LockElement>> {
        return this.http.post<Result<LockElement>, undefined>(`/groups/${primaryId}/locks`, undefined);
    }

    /**
     * Calls DELETE /groups/{primaryId}/locks
     */
    public unlock(primaryId: string): Promise<Result<boolean>> {
        return this.http.delete<Result<boolean>>(`/groups/${primaryId}/locks`);
    }

    /**
     * Calls GET /groups/{primaryId}
     */
    public get(primaryId: string, include: string | undefined): Promise<Result<ApiGroup>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ApiGroup>>(`/groups/${primaryId}`, query);
    }

    /**
     * Calls POST /groups
     */
    public add(dto: ApiGroup): Promise<Result<ApiGroup>> {
        return this.http.post<Result<ApiGroup>, ApiGroup>('/groups', dto);
    }

    /**
     * Calls PUT /groups/{primaryId}
     */
    public update(dto: ApiGroup, primaryId: string): Promise<Result<ApiGroup>> {
        return this.http.put<Result<ApiGroup>, ApiGroup>(`/groups/${primaryId}`, dto);
    }

    /**
     * Calls PATCH /groups
     */
    public putRange(dtos: ApiGroup[]): Promise<Result<ApiGroup[]>> {
        return this.http.patch<Result<ApiGroup[]>, ApiGroup[]>('/groups', dtos);
    }

    /**
     * Calls DELETE /groups/{primaryId}
     */
    public delete(primaryId: string): Promise<Result<boolean>> {
        return this.http.delete<Result<boolean>>(`/groups/${primaryId}`);
    }

    /**
     * Calls POST /groups:batch
     */
    public getBatch(listRequest: ListRequestWithIds, include: string | undefined): Promise<Result<ListInfo<ApiGroup>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiGroup>>, ListRequestWithIds>('/groups:batch', listRequest, query);
    }

    /**
     * Calls POST /groups:query
     */
    public getListPost(listRequest: ListRequest, include: string | undefined): Promise<Result<ListInfo<ApiGroup>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiGroup>>, ListRequest>('/groups:query', listRequest, query);
    }

    /**
     * Calls GET /groups:query
     */
    public getListGet(pageNo: number, pageSize: number, include: string | undefined): Promise<Result<ListInfo<ApiGroup>>> {
        const query = new URLSearchParams();
        query.set('pageNo', `${pageNo}`);
        query.set('pageSize', `${pageSize}`);
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ListInfo<ApiGroup>>>('/groups:query', query);
    }
}
